var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCounterPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.827,
    height: 25.827,
    viewBox: "0 0 25.827 25.827"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-counter-plus_svg__cls-1{fill:none;stroke:#009ceb;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-counter-plus_svg__ICN_Plus_Enabled",
    transform: "rotate(45 1187.474 -1956.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-counter-plus_svg__Line_276",
    "data-name": "Line 276",
    className: "kpmg-counter-plus_svg__cls-1",
    transform: "translate(1741.5 258.634)",
    d: "M0 0l16 15.999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-counter-plus_svg__Line_277",
    "data-name": "Line 277",
    className: "kpmg-counter-plus_svg__cls-1",
    transform: "translate(1741.5 258.634)",
    d: "M0 15.999L16 0"
  }))));
}

export default SvgKpmgCounterPlus;